module.exports = __webpack_public_path__ + "static/media/Twilio—Segment—Horizontal—DarkAcai.7f07cdd1.svg";